import { useTranslation } from "react-i18next";
import { Package, Plus } from "lucide-react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { volumesOptions } from "@/constants/options/volumes.option";
import { QuotationUpdateBoFormData } from "@/types/forms/bo/expeditionBo.form";
import { PackagingRow } from "./packagingRow";

export const Packaging = () => {
  const { t } = useTranslation("boExpeditionForm");
  const { control } = useFormContext<QuotationUpdateBoFormData>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "quotationWoodBox",
  });

  return (
    <AccordionItem
      value="packaging"
      className="shadow-basic flex w-full flex-col items-start justify-center gap-4 rounded-xl border border-gray-200 bg-slate-100 p-6"
    >
      <AccordionTrigger className="flex w-full flex-row items-start justify-between gap-2 self-start !no-underline">
        <div className="flex flex-row items-center gap-2 self-start">
          <Package className="h-6 w-6 !rotate-0 text-blue-600" />
          <p className="text-xl font-bold">{t("packaging.title")}</p>
        </div>
      </AccordionTrigger>
      <AccordionContent forceMount className="flex w-full flex-col gap-2">
        {fields.map((field, index) => (
          <PackagingRow key={field.id} index={index} onRemove={() => remove(index)} />
        ))}
        <Button
          className="w-fit"
          variant="outline"
          type="button"
          onClick={() =>
            append({
              bottleQuantity: "" as unknown as number,
              boxQuantity: 1,
              bottleVolume: volumesOptions[0].value,
            })
          }
        >
          <Plus className="h-4 w-4" />
          {t("packaging.add")}
        </Button>
      </AccordionContent>
    </AccordionItem>
  );
};
